"use strict";

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transaction = void 0;

var lisk_transactions_1 = require("@liskhq/lisk-transactions");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var lisk_codec_1 = require("@liskhq/lisk-codec");

var codec_1 = require("./codec");

var Transaction = /*#__PURE__*/function () {
  function Transaction(channel, registeredSchema, nodeInfo) {
    _classCallCheck(this, Transaction);

    this._channel = channel;
    this._schema = registeredSchema;
    this._nodeInfo = nodeInfo;
  }

  _createClass(Transaction, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, passphrase, options) {
        var _a, txInput, networkIdentifier, _lisk_cryptography_1$, publicKey, address, accountHex, account, registeredModule, _registeredModule, registeredAsset, assetSchema;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                txInput = input;
                networkIdentifier = Buffer.from(this._nodeInfo.networkIdentifier, 'hex');
                _lisk_cryptography_1$ = lisk_cryptography_1.getAddressAndPublicKeyFromPassphrase(passphrase), publicKey = _lisk_cryptography_1$.publicKey, address = _lisk_cryptography_1$.address;
                _context.next = 5;
                return this._channel.invoke('app:getAccount', {
                  address: address.toString('hex')
                });

              case 5:
                accountHex = _context.sent;
                account = codec_1.decodeAccount(Buffer.from(accountHex, 'hex'), this._schema);

                if (txInput.moduleID) {
                  _context.next = 14;
                  break;
                }

                if (txInput.moduleName) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Missing moduleID and moduleName');

              case 10:
                registeredModule = this._nodeInfo.registeredModules.find(function (module) {
                  return module.name === input.moduleName;
                });

                if (registeredModule) {
                  _context.next = 13;
                  break;
                }

                throw new Error("Module corresponding to name ".concat(txInput.moduleName, " not registered."));

              case 13:
                txInput.moduleID = registeredModule.id;

              case 14:
                if (!(typeof txInput.assetID !== 'number')) {
                  _context.next = 24;
                  break;
                }

                if (txInput.assetName) {
                  _context.next = 17;
                  break;
                }

                throw new Error('Missing assetID and assetName');

              case 17:
                _registeredModule = this._nodeInfo.registeredModules.find(function (m) {
                  return m.id === txInput.moduleID;
                });

                if (_registeredModule) {
                  _context.next = 20;
                  break;
                }

                throw new Error("Module corresponding to id ".concat(txInput.moduleID, " not registered."));

              case 20:
                registeredAsset = _registeredModule.transactionAssets.find(function (asset) {
                  return asset.name === txInput.assetName;
                });

                if (registeredAsset) {
                  _context.next = 23;
                  break;
                }

                throw new Error("Asset corresponding to name ".concat(txInput.assetName, " not registered."));

              case 23:
                txInput.assetID = registeredAsset.id;

              case 24:
                if (!(typeof txInput.nonce !== 'bigint')) {
                  _context.next = 28;
                  break;
                }

                if (!(typeof account.sequence !== 'object' || typeof account.sequence.nonce !== 'bigint')) {
                  _context.next = 27;
                  break;
                }

                throw new Error('Unsupported account type');

              case 27:
                txInput.nonce = account.sequence.nonce;

              case 28:
                if (!(txInput.nonce < BigInt(0))) {
                  _context.next = 30;
                  break;
                }

                throw new Error('Nonce must be greater or equal to zero');

              case 30:
                if (!txInput.senderPublicKey) {
                  txInput.senderPublicKey = publicKey;
                }

                txInput.signatures = (_a = txInput.signatures) !== null && _a !== void 0 ? _a : [];
                assetSchema = codec_1.getTransactionAssetSchema(txInput, this._schema);

                if (!(account.keys && account.keys.numberOfSignatures > 0)) {
                  _context.next = 35;
                  break;
                }

                return _context.abrupt("return", lisk_transactions_1.signMultiSignatureTransaction(assetSchema, txInput, networkIdentifier, passphrase, account.keys, options === null || options === void 0 ? void 0 : options.includeSenderSignature));

              case 35:
                if (!((options === null || options === void 0 ? void 0 : options.multisignatureKeys) && (options === null || options === void 0 ? void 0 : options.includeSenderSignature))) {
                  _context.next = 37;
                  break;
                }

                return _context.abrupt("return", lisk_transactions_1.signMultiSignatureTransaction(assetSchema, txInput, networkIdentifier, passphrase, options.multisignatureKeys, options.includeSenderSignature));

              case 37:
                return _context.abrupt("return", lisk_transactions_1.signTransaction(assetSchema, txInput, networkIdentifier, passphrase));

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x, _x2, _x3) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var idString, transactionHex;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idString = Buffer.isBuffer(id) ? id.toString('hex') : id;
                _context2.next = 3;
                return this._channel.invoke('app:getTransactionByID', {
                  id: idString
                });

              case 3:
                transactionHex = _context2.sent;
                return _context2.abrupt("return", codec_1.decodeTransaction(Buffer.from(transactionHex, 'hex'), this._schema));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x4) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getFromPool",
    value: function () {
      var _getFromPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var transactionsHex, decodedTransactions, _iterator, _step, transactionHex;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._channel.invoke('app:getTransactionsFromPool');

              case 2:
                transactionsHex = _context3.sent;
                decodedTransactions = [];
                _iterator = _createForOfIteratorHelper(transactionsHex);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    transactionHex = _step.value;
                    decodedTransactions.push(codec_1.decodeTransaction(Buffer.from(transactionHex, 'hex'), this._schema));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context3.abrupt("return", decodedTransactions);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getFromPool() {
        return _getFromPool.apply(this, arguments);
      }

      return getFromPool;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transaction, passphrases, options) {
        var assetSchema, networkIdentifier, address, accountHex, account, _iterator2, _step2, passphrase, _iterator3, _step3, _passphrase;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                assetSchema = codec_1.getTransactionAssetSchema(transaction, this._schema);
                networkIdentifier = Buffer.from(this._nodeInfo.networkIdentifier, 'hex');
                address = lisk_cryptography_1.getAddressFromPublicKey(transaction.senderPublicKey);
                _context4.next = 5;
                return this._channel.invoke('app:getAccount', {
                  address: address.toString('hex')
                });

              case 5:
                accountHex = _context4.sent;
                account = codec_1.decodeAccount(Buffer.from(accountHex, 'hex'), this._schema);

                if (!(account.keys && account.keys.numberOfSignatures > 0)) {
                  _context4.next = 11;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(passphrases);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    passphrase = _step2.value;
                    lisk_transactions_1.signMultiSignatureTransaction(assetSchema, transaction, networkIdentifier, passphrase, account.keys, options === null || options === void 0 ? void 0 : options.includeSenderSignature);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                return _context4.abrupt("return", transaction);

              case 11:
                if (!((options === null || options === void 0 ? void 0 : options.multisignatureKeys) && (options === null || options === void 0 ? void 0 : options.includeSenderSignature))) {
                  _context4.next = 15;
                  break;
                }

                _iterator3 = _createForOfIteratorHelper(passphrases);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _passphrase = _step3.value;
                    lisk_transactions_1.signMultiSignatureTransaction(assetSchema, transaction, networkIdentifier, _passphrase, options.multisignatureKeys, options.includeSenderSignature);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                return _context4.abrupt("return", transaction);

              case 15:
                return _context4.abrupt("return", lisk_transactions_1.signTransaction(assetSchema, transaction, networkIdentifier, passphrases[0]));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sign(_x5, _x6, _x7) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(transaction) {
        var encodedTx;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                encodedTx = codec_1.encodeTransaction(transaction, this._schema);
                return _context5.abrupt("return", this._channel.invoke('app:postTransaction', {
                  transaction: encodedTx.toString('hex')
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function send(_x8) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "decode",
    value: function decode(transaction) {
      var transactionBuffer = Buffer.isBuffer(transaction) ? transaction : Buffer.from(transaction, 'hex');
      return codec_1.decodeTransaction(transactionBuffer, this._schema);
    }
  }, {
    key: "encode",
    value: function encode(transaction) {
      return codec_1.encodeTransaction(transaction, this._schema);
    }
  }, {
    key: "computeMinFee",
    value: function computeMinFee(transaction) {
      var assetSchema = codec_1.getTransactionAssetSchema(transaction, this._schema);
      var numberOfSignatures = transaction.signatures ? transaction.signatures.length : 1;
      var options = {
        minFeePerByte: this._nodeInfo.genesisConfig.minFeePerByte,
        baseFees: this._nodeInfo.genesisConfig.baseFees,
        numberOfSignatures: numberOfSignatures
      };
      return lisk_transactions_1.computeMinFee(assetSchema, transaction, options);
    }
  }, {
    key: "toJSON",
    value: function toJSON(transaction) {
      var txAsset = transaction.asset,
          txRoot = _objectWithoutProperties(transaction, ["asset"]);

      var tmpId = txRoot.id;
      delete txRoot.id;
      var schemaAsset = codec_1.getTransactionAssetSchema(txRoot, this._schema);
      var jsonTxAsset = lisk_codec_1.codec.toJSON(schemaAsset, txAsset);
      var jsonTxRoot = lisk_codec_1.codec.toJSON(this._schema.transaction, txRoot);

      var jsonTx = _objectSpread({}, jsonTxRoot, {
        asset: jsonTxAsset,
        id: Buffer.isBuffer(tmpId) ? tmpId.toString('hex') : tmpId
      });

      return jsonTx;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(transaction) {
      var txAsset = transaction.asset,
          txRoot = _objectWithoutProperties(transaction, ["asset"]);

      var tmpId = txRoot.id;
      delete txRoot.id;
      var schemaAsset = codec_1.getTransactionAssetSchema(txRoot, this._schema);
      var txAssetObject = lisk_codec_1.codec.fromJSON(schemaAsset, txAsset);
      var txRootObject = lisk_codec_1.codec.fromJSON(this._schema.transaction, txRoot);

      var txObject = _objectSpread({}, txRootObject, {
        asset: txAssetObject,
        id: typeof tmpId === 'string' ? Buffer.from(tmpId, 'hex') : Buffer.alloc(0)
      });

      return txObject;
    }
  }]);

  return Transaction;
}();

exports.Transaction = Transaction;